import { ActivatedRoute } from '@angular/router';
import { Partners } from '@lockton-apps/shared/interfaces';
import { toInteger } from 'lodash';
import { NorwayDynamicFormsExtensionsService } from './services/norway/norway-dynamic-forms-extensions.service';
import { Inject, inject, Injectable } from '@angular/core';
import { DynamicFormsExtensionsService } from '@lockton-apps/dynamic-forms';
import { LsosDynamicFormsExtensionsService } from './services/lsos/lsos-dynamic-forms-extensions.service';
import { AccaDynamicFormsExtensionsService } from './services/acca/acca-dynamic-forms-extensions.service';
import { PncDynamicFormsExtensionsService } from './services/pnc/pnc-dynamic-forms-extensions.service';
import { ConstructionDynamicFormsExtensionsService } from './services/construction/construction-dynamic-forms-extensions.service';
import { EnwDynamicFormsExtensionsService } from './services/enw/enw-dynamic-forms-extensions.service';
import { RegulatoryDynamicFormsExtensionsService } from './services/regulatory/regulatory-dynamic-forms-extensions.service';
import { Observable } from 'rxjs';
import { PROPOSAL_PARTNER_DATA } from './constants/proposal-partner-data';
import { AccaOverDynamicFormsExtensionsService } from './services/acca-over/acca-over-dynamic-forms-extensions.service';

interface DefaultPartnerData {
  proposalId: string | undefined;
  createdDate: string;
}

@Injectable()
export class DefaultDynamicFormsExtensionsService extends DynamicFormsExtensionsService {
  constructor(
    @Inject(PROPOSAL_PARTNER_DATA)
    protected readonly partnerData$: Observable<DefaultPartnerData>
  ) {
    super();
  }
}

export function routedPortalExtensionsFactory(
  activatedRoute: ActivatedRoute
): DynamicFormsExtensionsService {
  const routedPortalId: Partners = toInteger(
    activatedRoute.snapshot.paramMap.get('portalId')
  );

  switch (routedPortalId) {
    case Partners.LSOS:
      return inject(LsosDynamicFormsExtensionsService);

    case Partners.NORWAY:
    case Partners.NORWAY_PI:
      return inject(NorwayDynamicFormsExtensionsService);

    case Partners.ACCA:
      return inject(AccaDynamicFormsExtensionsService);

    case Partners.ACCA_OVER:
      return inject(AccaOverDynamicFormsExtensionsService);

    case Partners.PNC:
      return inject(PncDynamicFormsExtensionsService);

    case Partners.CONSTRUCTION:
      return inject(ConstructionDynamicFormsExtensionsService);

    case Partners.ENW:
      return inject(EnwDynamicFormsExtensionsService);

    case Partners.REGULATORY:
      return inject(RegulatoryDynamicFormsExtensionsService);

    default:
      return inject(DefaultDynamicFormsExtensionsService);
  }
}
